import React from 'react';

const ModernPageWrapper = ({ children, title, subtitle, disableMobileCenter = false }) => {
  const wrapperClassName = `page-wrapper flex-1 p-8 bg-gray-50 min-h-screen w-80vw ${
    disableMobileCenter ? "no-mobile-center" : ""
  }`.trim();

  return (
    <div className={wrapperClassName}>
      {/* Page Header */}
      {title && (
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">{title}</h1>
          {subtitle && <p className="text-lg text-gray-600">{subtitle}</p>}
        </div>
      )}

      {/* Page Content */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        {children}
      </div>
    </div>
  );
};

export default ModernPageWrapper;
